import PodcastDetails from '../../components/Podcast/PodcastDetails'
// import EpisodeTimeline from '../../components/Podcast/EpisodeTimeline'
// import PatreonSupport from '../../components/Podcast/PatreonSupport'
// import CreativitySection from '../../components/Podcast/CreativitySection'
import DescriptionSection from '../../components/Podcast/DescriptionSection'
import CommentSection from '../../components/Podcast/CommentSection'
// import RelatedShows from '../../components/Podcast/RelatedShows'
import ShareButtons from '../../components/Podcast/ShareButtons'
import Sidebar from '../../components/Podcast/Sidebar'
import Footer from '../../components/Footer'

// Import necessary dependencies to fetch data
import { PodCastAPI } from '../../apis/PodcastAPI'
import ShallowHeader from '../../components/ShallowHeader'
import RelatedPodcasts from '../../components/Podcast/RelatedPodcasts'

export default function PodcastPage({
    podcast,
    relatedPosts,
    categories,
    tags,
}) {
    if (!podcast) {
        return <div>Loading...</div>
    }

    return (
        <div className="space-y-10 md:space-y-20">
            <ShallowHeader
                meta={podcast?.yoast_head || ''}
                title={
                    podcast?.yoast_head_json?.title ??
                    podcast?.title?.rendered ??
                    podcast?.title ??
                    'Podcast'
                }
            />
            <PodcastDetails podcast={podcast} tags={tags} />
            <div className="container mx-auto md:grid grid-cols-3 gap-8 px-6 space-y-6 md:space-y-0">
                <div className="col-span-2 raw-html max-w-full">
                    <DescriptionSection
                        description={podcast?.content.rendered}
                    />
                    <ShareButtons />
                </div>

                <div className="col-span-1">
                    <Sidebar categories={categories} tags={tags} />
                </div>
            </div>
            <CommentSection post={podcast} />
            <div>
                {relatedPosts.length > 0 && (
                    <RelatedPodcasts podcasts={relatedPosts} />
                )}
                <Footer />
            </div>
        </div>
    )
}

// This function generates paths for each podcast based on the slug
export async function getStaticPaths() {
    const podcasts = await PodCastAPI.getAllInOneShot()

    const paths = podcasts.map((podcast) => ({
        params: { slug: podcast.slug },
    }))

    return {
        paths,
        fallback: true, // Can also be 'blocking' if you want to wait for the full page to be generated
    }
}

// This function fetches data for each individual podcast based on the slug
export async function getStaticProps({ params }) {
    const podcast = await PodCastAPI.getBySlug(params.slug)

    if (!podcast) {
        return {
            notFound: true,
        }
    }

    const categories = await PodCastAPI.getCategories()
    const tags = await PodCastAPI.getTags()

    const relatedPosts = podcast?.podcast_category?.length
        ? (await PodCastAPI.getRelatedPosts(
              podcast.id,
              podcast.podcast_category,
          )) || []
        : []

    return {
        props: {
            podcast,
            categories,
            tags,
            relatedPosts,
        },
        revalidate: 10, // Optional: Revalidate every 10 seconds
    }
}
